import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Image from 'gatsby-image';
import TextTruncate from 'react-text-truncate';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

const BlogTemplate = ({ items }) => (
  <div className="row flex-wrap">
    <div className="col-xs-12 col-sm-8">
      <div className="content">
        <div className="title-group">
          <h2 className="title-2">Блог</h2>
        </div>
        {items.map(({
          node: {
            id, title, slug, createdAt, image, body: { json: body },
          },
        }) => (
            <Link to={`/blog/${slug}/`} className="articles-card" key={id}>
              <div className="articles-preview">
                <Image className="articles-thumb" fixed={image.fixed} alt={title} />
              </div>
              <div className="articles-content">
                <span className="articles-title">{title}</span>
                <p className="articles-description">
                  <TextTruncate line={2} truncateText="…" text={documentToPlainTextString(body)} />
                </p>
                <div className="articles-info">
                  <time className="articles-date">{createdAt}</time>
                </div>
              </div>
            </Link>
          ))}
      </div>
    </div>
    <div className="col-xs-12 col-sm-4 sidebar">
      <div className="box-container">
        <div className="box-content">
          <div id="yandex_rtb_R-A-599273-4"></div>
          <script
            id="gatsby-plugin-yandex-direct"
            key={`gatsby-plugin-yandex-direct`}
            dangerouslySetInnerHTML={{
              __html: `(function(w, d, n, s, t) {
                          w[n] = w[n] || [];
                          w[n].push(function() {
                              Ya.Context.AdvManager.render({
                                  blockId: "R-A-599273-4",
                                  renderTo: "yandex_rtb_R-A-599273-4",
                                  async: true
                              });
                          });
                          t = d.getElementsByTagName("script")[0];
                          s = d.createElement("script");
                          s.type = "text/javascript";
                          s.src = "//an.yandex.ru/system/context.js";
                          s.async = true;
                          t.parentNode.insertBefore(s, t);
                      })(this, this.document, "yandexContextAsyncCallbacks");`
            }}
          />
        </div>
      </div>
    </div>
  </div>
);

BlogTemplate.propTypes = {
  contacts: PropTypes.shape({
    instagram: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired,
    vk: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
  }).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default BlogTemplate;
